module.exports = __webpack_public_path__ + "f799f34c7e198e4a6b9b328b1f77a0b8.png";